import { lazy } from 'react';

export const PlayerMarketingPhoneForm = lazy(
  () => import('./PlayerMarketingPhoneForm'),
);
